import { render, staticRenderFns } from "./TopluTebligatDuzenleForm.vue?vue&type=template&id=0790cf91"
import script from "./TopluTebligatDuzenleForm.vue?vue&type=script&lang=ts"
export * from "./TopluTebligatDuzenleForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports